import script from "./nyNav.vue?vue&type=script&setup=true&lang=js"
export * from "./nyNav.vue?vue&type=script&setup=true&lang=js"

import "./nyNav.vue?vue&type=style&index=0&id=5ca92897&lang=less&scoped=true"
script.__scopeId = "data-v-5ca92897"

export default script